
export class BrowseItem {
  name: string;
  value: string;
  count: number;

  constructor(name: string, value: string, count: number) {
    this.name = name;
    this.value = value;
    this.count = count;
  }

}
